const MAX_BEACONS_PER_PAGE = 5;
let beaconCount = 0;

interface ImageErrorReport {
  url: string;
  retryCount: number;
  catalogId?: string;
}

const stripQueryParams = (url: string): string => {
  try {
    const parsed = new URL(url);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    // If URL parsing fails, strip everything after ?
    const qIndex = url.indexOf('?');
    return qIndex >= 0 ? url.substring(0, qIndex) : url;
  }
};

export const sendImageErrorBeacon = (report: ImageErrorReport): void => {
  if (beaconCount >= MAX_BEACONS_PER_PAGE) return;
  beaconCount += 1;

  const payload = JSON.stringify({
    url: stripQueryParams(report.url).substring(0, 500),
    retryCount: report.retryCount,
    catalogId: report.catalogId ?? null,
    userAgent: navigator.userAgent.substring(0, 500),
    timestamp: new Date().toISOString(),
  });

  const apiBase = import.meta.env.VITE_API_URL || '';
  const url = `${apiBase}/api/telemetry/image-error`;

  const sent =
    typeof navigator.sendBeacon === 'function' &&
    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));

  if (!sent) {
    fetch(url, {
      method: 'POST',
      body: payload,
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
    }).catch(() => {
      /* telemetry is best-effort */
    });
  }
};

/** Exported for testing only */
export const _resetBeaconCount = (): void => {
  beaconCount = 0;
};
